import { render, staticRenderFns } from "./StatisticChartGroup.vue?vue&type=template&id=3a8cef97&scoped=true&"
import script from "./StatisticChartGroup.vue?vue&type=script&lang=ts&"
export * from "./StatisticChartGroup.vue?vue&type=script&lang=ts&"
import style0 from "./StatisticChartGroup.vue?vue&type=style&index=0&id=3a8cef97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8cef97",
  null
  
)

export default component.exports